import React, { useState, useEffect, useRef } from 'react';
import { Editor } from 'primereact/editor';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import PrintTemplateService from '../../services/PrintTemplateService';

const placeholders = [
    { label: 'Firma Adı', value: '{{FirmaAdi}}' },
    { label: 'Firma Adresi', value: '{{FirmaAdresi}}' },
    { label: 'Firma Telefon', value: '{{FirmaTelefon}}' },
    { label: 'Teklif No', value: '{{TeklifNo}}' },
    { label: 'Teklif Tarihi', value: '{{TeklifTarihi}}' },
    { label: 'Geçerlilik Tarihi', value: '{{GecerlilikTarihi}}' },
    { label: 'Müşteri Adı', value: '{{MusteriAdi}}' },
    { label: 'Müşteri Adresi', value: '{{MusteriAdresi}}' },
    { label: 'Müşteri Telefon', value: '{{MusteriTelefon}}' },
    { label: 'Ara Toplam', value: '{{AraToplam}}' },
    { label: 'KDV Toplam', value: '{{KdvToplam}}' },
    { label: 'Genel Toplam', value: '{{GenelToplam}}' },
    { label: 'Teklif Notu', value: '{{TeklifNotu}}' },
    { label: 'Ürün Tablosu', value: '{{UrunTablosu}}' },
];

const defaultTemplate = `<div style="font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #334155; line-height: 1.6; padding: 10px; background: #fff;">
    <!-- Top Accent Bar -->
    <div style="height: 6px; background: linear-gradient(90deg, #6366f1 0%, #06b6d4 100%); border-radius: 3px 3px 0 0; margin-bottom: 20px;"></div>
    
    <!-- Header Block -->
    <div style="display: flex; justify-content: space-between; align-items: center; padding: 0 10px; margin-bottom: 30px;">
        <div>
            <h1 style="margin: 0; font-size: 26pt; font-weight: 800; color: #1e293b; letter-spacing: -0.5px; text-transform: uppercase;">TEKLİF FORMU</h1>
            <p style="margin: 4px 0 0 0; font-size: 10pt; color: #64748b; font-weight: 500;">Kasım Benim Muhasebe Sistemi</p>
        </div>
        <div style="text-align: right;">
            <h2 style="margin: 0; font-size: 15pt; font-weight: 700; color: #6366f1; text-transform: uppercase;">{{FirmaAdi}}</h2>
            <p style="margin: 2px 0 0 0; font-size: 8.5pt; color: #64748b;">{{FirmaTelefon}}</p>
        </div>
    </div>

    <!-- Metadata Panel -->
    <div style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px; margin-bottom: 30px; display: flex; justify-content: space-between; align-items: center;">
        <div style="text-align: center; flex: 1; border-right: 1px solid #cbd5e1;">
            <span style="font-size: 7.5pt; font-weight: 700; text-transform: uppercase; color: #94a3b8; display: block; margin-bottom: 4px;">Teklif Numarası</span>
            <strong style="font-size: 11pt; color: #0f172a;">{{TeklifNo}}</strong>
        </div>
        <div style="text-align: center; flex: 1; border-right: 1px solid #cbd5e1;">
            <span style="font-size: 7.5pt; font-weight: 700; text-transform: uppercase; color: #94a3b8; display: block; margin-bottom: 4px;">Teklif Tarihi</span>
            <strong style="font-size: 11pt; color: #0f172a;">{{TeklifTarihi}}</strong>
        </div>
        <div style="text-align: center; flex: 1;">
            <span style="font-size: 7.5pt; font-weight: 700; text-transform: uppercase; color: #94a3b8; display: block; margin-bottom: 4px;">Geçerlilik Tarihi</span>
            <strong style="font-size: 11pt; color: #ef4444;">{{GecerlilikTarihi}}</strong>
        </div>
    </div>

    <!-- Info Block: Sender & Receiver -->
    <div style="display: flex; gap: 30px; margin-bottom: 35px;">
        <!-- Sender (Firma) -->
        <div style="flex: 1;">
            <h3 style="margin: 0 0 10px 0; font-size: 9.5pt; font-weight: 800; color: #6366f1; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 2px solid #e2e8f0; padding-bottom: 6px;">Teklif Veren (Hizmet Sağlayıcı)</h3>
            <div style="font-size: 10pt; font-weight: 700; color: #0f172a; margin-bottom: 6px;">{{FirmaAdi}}</div>
            <div style="font-size: 9pt; color: #475569; line-height: 1.5; margin-bottom: 8px;">{{FirmaAdresi}}</div>
            <div style="font-size: 9pt; color: #475569;"><span style="font-weight: 600; color: #334155;">Telefon:</span> {{FirmaTelefon}}</div>
        </div>
        
        <!-- Receiver (Müşteri) -->
        <div style="flex: 1;">
            <h3 style="margin: 0 0 10px 0; font-size: 9.5pt; font-weight: 800; color: #0f172a; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 2px solid #e2e8f0; padding-bottom: 6px;">Teklif Edilen (Müşteri)</h3>
            <div style="font-size: 10pt; font-weight: 700; color: #0f172a; margin-bottom: 6px;">{{MusteriAdi}}</div>
            <div style="font-size: 9pt; color: #475569; line-height: 1.5; margin-bottom: 8px;">{{MusteriAdresi}}</div>
            <div style="font-size: 9pt; color: #475569;"><span style="font-weight: 600; color: #334155;">Telefon:</span> {{MusteriTelefon}}</div>
        </div>
    </div>

    <!-- Items Section -->
    <div style="margin-bottom: 30px;">
        <h3 style="margin: 0 0 12px 0; font-size: 9.5pt; font-weight: 800; color: #0f172a; text-transform: uppercase; letter-spacing: 0.5px;">Ürün ve Hizmet Kalemleri</h3>
        {{UrunTablosu}}
    </div>

    <!-- Bottom Section: Notes & Totals -->
    <div style="display: flex; justify-content: space-between; gap: 30px; margin-bottom: 40px; align-items: flex-start;">
        <!-- Left: Notes -->
        <div style="flex: 1.2; background: #f8fafc; border-left: 4px solid #6366f1; padding: 15px; border-radius: 0 8px 8px 0; border-top: 1px solid #e2e8f0; border-bottom: 1px solid #e2e8f0; border-right: 1px solid #e2e8f0;">
            <h4 style="margin: 0 0 8px 0; font-size: 9pt; font-weight: 700; color: #0f172a; text-transform: uppercase;">Teklif Notları & Koşullar</h4>
            <div style="font-size: 8.5pt; color: #475569; line-height: 1.5; white-space: pre-wrap;">{{TeklifNotu}}</div>
        </div>
        
        <!-- Right: Totals Table -->
        <div style="flex: 0.8; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 15px;">
            <table style="width: 100%; border-collapse: collapse; font-size: 9pt;">
                <tr>
                    <td style="padding: 6px 0; color: #64748b;">Ara Toplam:</td>
                    <td style="padding: 6px 0; text-align: right; font-weight: 600; color: #1e293b;">{{AraToplam}}</td>
                </tr>
                <tr>
                    <td style="padding: 6px 0; color: #64748b; border-bottom: 1px solid #e2e8f0; padding-bottom: 10px;">KDV Toplam:</td>
                    <td style="padding: 6px 0; text-align: right; font-weight: 600; color: #1e293b; border-bottom: 1px solid #e2e8f0; padding-bottom: 10px;">{{KdvToplam}}</td>
                </tr>
                <tr>
                    <td style="padding: 12px 0 0 0; font-weight: 700; color: #0f172a; font-size: 10pt;">GENEL TOPLAM:</td>
                    <td style="padding: 12px 0 0 0; text-align: right; font-weight: 800; color: #6366f1; font-size: 12pt;">{{GenelToplam}}</td>
                </tr>
            </table>
        </div>
    </div>

    <!-- Signatures -->
    <div style="margin-top: 50px; display: flex; justify-content: space-between; padding: 0 20px;">
        <div style="text-align: center; width: 220px;">
            <p style="margin: 0 0 45px 0; font-size: 9pt; font-weight: 700; color: #64748b; text-transform: uppercase;">TEKLİF VEREN YETKİLİ</p>
            <div style="border-top: 1px dashed #cbd5e1; padding-top: 8px; font-size: 9pt; font-weight: 600; color: #0f172a;">{{FirmaAdi}}</div>
            <span style="font-size: 7.5pt; color: #94a3b8; display: block; margin-top: 2px;">İmza / Kaşe</span>
        </div>
        <div style="text-align: center; width: 220px;">
            <p style="margin: 0 0 45px 0; font-size: 9pt; font-weight: 700; color: #64748b; text-transform: uppercase;">MÜŞTERİ ONAYI</p>
            <div style="border-top: 1px dashed #cbd5e1; padding-top: 8px; font-size: 9pt; font-weight: 600; color: #0f172a;">{{MusteriAdi}}</div>
            <span style="font-size: 7.5pt; color: #94a3b8; display: block; margin-top: 2px;">Tarih / İmza</span>
        </div>
    </div>
</div>`;

export default function QuotationPrintSettingsPage() {
    const [template, setTemplate] = useState('');
    const [loading, setLoading] = useState(false);
    const [quillInstance, setQuillInstance] = useState(null);
    const toast = useRef(null);

    useEffect(() => {
        setLoading(true);
        PrintTemplateService.getTemplate('quotation').then(res => {
            if (res.success && res.data) {
                setTemplate(res.data.content);
            } else {
                setTemplate(defaultTemplate);
            }
            setLoading(false);
        });
    }, []);

    const handleSave = async () => {
        setLoading(true);
        try {
            const res = await PrintTemplateService.saveTemplate({
                templateType: 'quotation',
                content: template
            });
            if (res.success) {
                toast.current.show({ severity: 'success', summary: 'Başarılı', detail: 'Teklif tasarımı kaydedildi.' });
            }
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Kaydedilemedi.' });
        } finally {
            setLoading(false);
        }
    };

    const insertPlaceholder = (value) => {
        if (quillInstance) {
            const range = quillInstance.getSelection(true);
            quillInstance.insertText(range.index, value);
        }
    };

    return (
        <div className="p-4 space-y-4 bg-[#f8fafc] min-h-screen">
            <Toast ref={toast} />
            <div className="flex justify-between items-center">
                <div className="flex items-center gap-3">
                    <div className="!bg-indigo-600 p-4 rounded-xl shadow-lg">
                        <i className="pi pi-print text-white text-xl"></i>
                    </div>
                    <div>
                        <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tight">Teklif Tasarımı</h1>
                        <p className="text-slate-500 text-sm font-medium">Teklif belgeleri için PDF/Word şablonunu buradan düzenleyebilirsiniz.</p>
                    </div>
                </div>
                <Button label="TASARIMI KAYDET" icon="pi pi-save" className="p-button-success rounded-xl font-black px-6" onClick={handleSave} loading={loading} />
            </div>

            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12 lg:col-span-3">
                    <Card title="Dinamik Veriler" className="shadow-sm border-round-xl">
                        <p className="text-xs text-slate-500 mb-3">Tıklayarak editöre ekleyebilirsiniz.</p>
                        <div className="flex flex-col gap-2">
                            {placeholders.map(p => (
                                <Button key={p.value} label={p.label} className="p-button-outlined p-button-secondary text-xs text-left justify-content-start"
                                        onClick={() => insertPlaceholder(p.value)} />
                            ))}
                        </div>
                    </Card>
                </div>
                <div className="col-span-12 lg:col-span-9">
                    <Card className="shadow-sm border-round-xl">
                        <Editor value={template} onTextChange={(e) => setTemplate(e.htmlValue)}
                                onLoad={(quill) => setQuillInstance(quill)} style={{ height: '600px' }} />
                    </Card>
                </div>
            </div>
        </div>
    );
}
